import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "store/types";

interface PublicRouteProps {
  children: JSX.Element;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const auth = useSelector((state: RootState) => state.auth);
  const isAuthenticated = !!auth.accessToken && !!auth.userId;

  return isAuthenticated ? <Navigate to="/org/home" replace /> : children;
};

export default PublicRoute;
